import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import {updateSupplier,getSupplier} from '../../redux/actions/Supplier/SupplierAction';
import './SupplierStyle.css';

const SupplierUpdateProfile = ({supplier, updateSupplier,getSupplier}) =>{

    const [supplierName, setSupplierName] = useState(supplier.supplierName);
    const [supplierPhoneNumber, setSupplierPhoneNumber] = useState(supplier.supplierPhoneNumber);

    useEffect(()=>{
        setSupplierName(supplier.supplierName);
        setSupplierPhoneNumber(supplier.supplierPhoneNumber);
    },[supplier]);

    const params = useParams();
    useEffect(()=>{
        if(supplier && supplier.length === 0)
            getSupplier(params.supplierId);
    },[supplier]);

    const HandleSubmit = (e) => {
        e.preventDefault();
        console.log('->'+supplierPhoneNumber,supplierName);
        updateSupplier(params.supplierId,{supplierName, supplierPhoneNumber});
        toast.success('Updates Successfully');
    };

    return(
        
        <div className="container-fluid update-profile-page">
            <h1 className='update-profile-header'>Update Profile</h1>
            <div className="row">
                <div className="col-md-6 p-3 mx-auto shadow update-profile-box">
                    <form onSubmit={HandleSubmit}>
                        <div className="form-group my-3">
                            <input
                                className="form-control"
                                type="text"
                                placeholder="Name"
                                value={supplierName}
                                onChange={(e)=> setSupplierName(e.target.value)}
                            />
                        </div>
                        <div className="form-group my-3">
                            <input
                                className="form-control"
                                type="number"
                                placeholder="Phone Number"
                                value={supplierPhoneNumber}
                                onChange={(e)=>setSupplierPhoneNumber(e.target.value)}
                            />
                        </div>
                        <div className='add-product-buttons'>
                            <div className="form-group my-3 px-1">
                                <button type="submit" className="btn btn-primary">
                                    Submit
                                </button>
                                <button type="submit" className="btn btn-primary mx-5 px-4" onClick={()=>history.go(-1)}>
                                    Back
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <ToastContainer />
        </div>
    );
};

const mapStateToProps = (state) => {
    console.log(state.suppliers);
    return{supplier: state.suppliers};

};

const mapDispatchToProps = {
    updateSupplier, 
    getSupplier,
};


export default connect(mapStateToProps, mapDispatchToProps)(SupplierUpdateProfile);